import { Box, SkeletonRectangle } from '@wix/design-system';
import React from 'react';
import s from './tldOfferCard.scss';
export const TldOfferPricingSkeleton = () => /*#__PURE__*/React.createElement(Box, {
  direction: "vertical",
  gap: "6px",
  width: "139px"
}, /*#__PURE__*/React.createElement(SkeletonRectangle, {
  className: s.skeleton,
  width: "115px",
  height: "18px"
}), /*#__PURE__*/React.createElement(SkeletonRectangle, {
  className: s.skeleton,
  width: "138px",
  height: "20px"
}));
//# sourceMappingURL=TldOfferPricingSkeleton.js.map